import React from 'react'
import { withRouter } from 'react-router'
import { Button, Icon, CircularProgressBar, Image } from 'components/library'
import { translate } from 'translations'
import './Card.css'

const Card = props => {
  const classNames = ['Card']

  if(!props.static) {
    if (props.status === 'done') classNames.push('has-status-done')
    if (props.status === 'active') classNames.push('has-status-active')
    if (props.status === 'locked') classNames.push('has-status-locked')
  }
  const handleClick = e => {
    props.history.push(props.to)
  }

  return (
    <div className={classNames.join(' ')} onClick={handleClick}>
      <div className="Card-icon">
        { (props.icon && <CardIcon src={props.icon} />)
        || ((props.status === 'active' || props.status === 'notpassed') &&
          <CircularProgressBar
            label={`${props.progress}/${props.total}`}
            percentage={Math.floor(props.progress/props.total*100)}
            sqSize={100}
            strokeWidth={10} />)
        || (props.status === 'done' && <CardIcon name={"check"} />)
        || (props.status === 'locked' && <CardIcon name={"lock"} />)
        }
      </div>
      <div className="Card-title">
        {props.title}
      </div>
      <div className="Card-action">
        <Button static full square
          disabled={props.status === 'locked'}
          primary={props.status === 'active' || props.status === 'notpassed' || props.static}
          label={props.label || (props.status === 'done'
            ? translate('card.again')
            : props.status === 'notpassed'
              ? translate('endtest.btnResults')
              : props.progress > 0
                ? translate('card.continue')
                : translate('card.start'))} />
      </div>
    </div>
  )
}

const CardIcon = props => {

  let cardClass = "Card-status Card-"+props.name+"-icon";
  return (
      <div className={cardClass}>
        <div className="Card-status-icon">
          {props.name && <Icon name={props.name}/>}
          {props.src && <Image src={props.src} style={{width:'50%'}}/>}
        </div>
      </div>
  )
}
export default withRouter(Card)



// WEBPACK FOOTER //
// ./src/components/library/card/Card.js